<template>
  <div class="__dashboard">
    <!--
    <router-link class="backlink text-white" to="/">
      <i class="fal fa-chevron-left mr-xs"></i>
      <span>To MIS Website</span>
    </router-link>
    <div class="dashboard--menu">
      <a
        class="marketcase"
        target="_blank"
        href="https://market.mis-implants.com"
      >
        <div class="link-inner">
          <img
            src="/img/dashboard/marketcase.png"
            alt="MIS Market"
            title="MIS Market"
          />
        </div>
        <span>MIS Market</span>
      </a>
      <a
        class="catcase"
        target="_blank"
        href="https://www.blossom-kc.com/platform/mis"
      >
        <div class="link-inner">
          <img
            src="/img/dashboard/catcase.png"
            alt="MIS Learning Management System"
            title="MIS Learning Management System"
          />
        </div>
        <span>MIS Learning</span>
      </a>
      <a
        class="salescase _disabled"
        target="_blank"
        href="http://il-s1-srv-05:81"
      >
        <div class="link-inner">
          <img src="/img/dashboard/salescase.png" alt="MIS Sales" />
        </div>
        <span>MIS Sales & Marketing</span>
      </a>
    </div>
    -->
  </div>
</template>

<script>
export default {
  created() {
    window.location.replace("https://market.mis-implants.com/");
  }
  //
};
//window.location.replace("https://google.com"); 

</script>

<style lang="stylus" scoped>
.dashboard
  .backlink
    position absolute
    top 10px
    left 10px
    i
      font-size 80%
    +desktop()
      &:hover
        text-decoration underline
  position fixed 0 0 0 0
  z-index 99999999
  background url(/img/dashboard/cover.jpg) no-repeat 50% 50% / cover
  &--menu
    center()
    _flex(row, nowrap, center, space-evenly)
    width 80%
    a
      position relative
      flex 0 0 30%
      opacity 1
      max-width 240px
      min-width 200px
      .link-inner
        position relative
        width 100%
        padding-top 100%
        // background-color rgba(#00acec, 0.6)
        background-color #00acec
        border-radius 100%
        overflow hidden
        box-shadow 0 0 6px rgba(#fff, 0.1)
        will-change background-color, opacity, box-shadow
        transition opacity 0.3s ease-out, background-color 0.3s ease-out, box-shadow 0.3s ease-out
      img
        center()
        max-width 100%
        max-height 100%
      span
        display block
        text-align center
        color #fff
        font-size 20px
        margin-top 10px
      +below(767px)
        min-width 140px
      +desktop()
        &:hover
          .link-inner
            box-shadow 0 0 6px rgba(#fff, 0.6)
    +portrait()
      +below(1023px)
        height 80vh
        _flex(column, wrap, center, space-evenly)
      +below(600px)
        height 90vh
        a
          min-width auto
          width 140px
</style>
